import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[mtmAgAlpineTheme]',
  standalone: false,
})
export class AgAlpineThemeDirective implements AfterViewInit {
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.replaceTheme();
  }

  private replaceTheme() {
    const nativeEl: HTMLElement = this.el.nativeElement;

    Array.from(nativeEl.classList)
      .filter((cls) => cls.startsWith('ag-theme-'))
      .forEach((cls) => this.renderer.removeClass(nativeEl, cls));
    this.renderer.addClass(nativeEl, 'ag-theme-alpine');
  }
}
